import cc from 'classcat';
import Linkify from 'linkify-react';

export type StatusColor = 'apporoved' | 'pending' | 'rejected' | 'inactive';

interface IAccordionItem {
    title: string;
    value: React.ReactNode;
    blueText?: boolean;
    statusColor?: StatusColor;
    vertical?: boolean;
    style?: React.CSSProperties;
}

export const AccordionItem = ({ title, value, blueText, statusColor, vertical, style }: IAccordionItem) => {
    return (
        <div className={cc(['accordion-item', { 'accordion-item--vertical': vertical }])}>
            <p className="paragraph-4 accordion-item__key">{title}</p>
            <div
                style={style}
                className={cc([
                    'paragraph-3',
                    'accordion-item__value',
                    { 'accordion-item__value--blue': blueText },
                    statusColor && `accordion-item__value--${statusColor}`,
                ])}
            >
                <Linkify>{value}</Linkify>
            </div>
        </div>
    );
};
